class Quentinha {

    constructor() {

        this.button = document.querySelector('.button-quentinhas');
        this.modal = document.querySelector('.modal-quentinhas');
        this.buttonClose = document.querySelector('.fire-close');
        this.overlay = document.querySelector('.modal-quentinhas > .overlay');

        if (!this.button) {
            console.warn('Elemento ".button-quentinhas" não encontrado.');
            return;
        }

        this.startAnimation();
        this.bindEvents();

    }

    startAnimation() {

        const ANIMATION_DELAY = 6500;

        this.animationTimeout = setTimeout(() => {
            this.button.classList.add('finish');
        }, ANIMATION_DELAY);

    }

    bindEvents() {

        if (this.modal) {

            this.button.addEventListener('click', () => {
                this.openModal();
            })

        }

        if (this.buttonClose) {
            this.buttonClose.addEventListener('click', () => {
                this.closeModal();
            })
        }

        if (this.overlay) {

            document.addEventListener('click', (event) => {
                if (!this.overlay.contains(event.target) && this.modal.classList.contains('opened')) {
                    this.closeModal();
                }
            })

        }

    }

    openModal() {
        clearTimeout(this.animationTimeout);
        this.button.classList.add('finish');
        this.modal.classList.add('opened')
        Piki.lockScroll()
    }

    closeModal() {
        this.modal.classList.remove('opened')
        Piki.unlockScroll()
    }

}

document.addEventListener('DOMContentLoaded', () => {
    new Quentinha();
});